import { app } from '../../app.module'
/**
 * タグフィルタリングフォーム
 * @class TagFilterForm
 */
class TagFilterForm {
  // フォームタイプ: 例: postTag, accountTag
  private snsType: string
  private type: string
  private label: string
  private selectedTags: string[]
  private currentSelectedTags: string[]
  private tagList: {
    value: string
    count: number
  }[]
  private filterType: string
  private targetType: string
  private targetQueryOptions: any
  private analyticsTab: string
  private onClose: Function

  constructor(
    private PostService,
    private AccountService,
    private AnalyticsCorrelationService
  ) {}

  /**
   * 初期化イベント
   * @returns void
   */
  public $onInit(): void {
    switch (this.filterType) {
      case 'postTag':
        this.label = '投稿タグ(AND検索)'
        break
      case 'accountTag':
        this.label = 'アカウントタグ(AND検索)'
        break
    }
  }

  /**
   * 渡したタグリストの変更イベント
   * @returns void
   */
  public $onChanges(): void {
    this.selectedTags = this.currentSelectedTags

    // タグリストがない かつ 選択したタグリストがある場合、タグリストは選択したタグリストから生成
    if (!this.tagList && this.currentSelectedTags) {
      this.tagList = this.currentSelectedTags.map((tag) => {
        return {
          value: tag,
          count: 1,
        }
      })
    }
  }

  /**
   * タグリストを取得
   * @returns void
   */
  private getTagList() {
    switch (this.targetType) {
      case 'post':
        const filterType = this.filterType === 'postTag' ? 'getTag' : 'getAccountTag'
        this.targetQueryOptions.isHashtagScreen = this.analyticsTab === 'hashtag' ? true : false
        return this.PostService.Search.getTagList(
          filterType,
          this.snsType,
          this.targetQueryOptions
        ).then((result) => {
          this.tagList = result
          this.checkCurrentSelectedTags()
          return
        })

      case 'account':
        this.tagList = this.AccountService.Filtering.getTagList()
        this.checkCurrentSelectedTags()
        return

      case 'correlation':
        this.tagList = this.AnalyticsCorrelationService.getTagList()
        this.checkCurrentSelectedTags()
        return
    }
  }

  /**
   * 選択したタグリストを変更する時の処理
   * @returns void
   */
  private changeSelectedTags() {
    if (!this.selectedTags || this.selectedTags.length === 0) {
      this.selectedTags = null
    }

    if (this.checkSameTagList()) {
      return
    }

    this.onClose({ selectedTags: this.selectedTags })
  }

  /**
   * 選択したタグリストの表示用のデータをセット
   * @returns {string} 選択したタグリストの表示用のデータ
   */
  private setSelectedTagsShow() {
    // タグを選択しない場合、対象タグのラベルを表示
    if (!this.selectedTags || this.selectedTags.length === 0) {
      return this.label
    }
    return this.selectedTags
  }

  /**
   * 今度フィルターするタグリストが既にフィルターしたタグリストと同じか確認
   * @returns {boolean}
   */
  private checkSameTagList() {
    const currentTags = this.currentSelectedTags
    const newTags = this.selectedTags

    // どちらもタグリストがない場合
    if (!currentTags && !newTags) {
      return true
    }

    // 既にフィルターしたタグリストがない場合
    if (!currentTags) {
      return false
    }

    // 今度フィルターするタグリストがない場合
    if (!newTags) {
      return false
    }

    return (
      currentTags.every((tag) => newTags.indexOf(tag) > -1) &&
      newTags.every((tag) => currentTags.indexOf(tag) > -1)
    )
  }

  /**
   * 選択したタグがタグリストに存在するか確認
   */
  private checkCurrentSelectedTags() {
    if (!this.selectedTags || this.selectedTags.length === 0) {
      return
    }

    // タグリストがない場合、選択したタグをNULLにする
    if (this.tagList.length === 0) {
      this.selectedTags = null
      return
    }
    // タグリストが選択したタグを含まない場合、リストから解除
    const tagNameList = this.tagList.map((tag) => tag.value)
    const selectedTags = this.selectedTags.filter((tag) => tagNameList.indexOf(tag) > -1)
    this.selectedTags = !selectedTags || selectedTags.length === 0 ? null : selectedTags
  }
}

/**
 * タグフィルタリングフォーム
 * attr: {string} snsType facebook or twitter or instagram or youtube or line
 * attr: {string} filterType account or post
 * attr: {string} targetType post(投稿データ) or account(アカウント投稿) or correlation(相関データ)
 * attr: {any} targetQueryOptions データ取得用のオプション
 * attr: {string[]} currentSelectedTags 選択しているタグ
 * attr: {function} onClose オプションを閉じるイベント
 */
app.component('tagFilterForm', {
  bindings: {
    snsType: '<',
    filterType: '@',
    targetType: '@',
    targetQueryOptions: '<',
    currentSelectedTags: '<',
    analyticsTab: '<',
    onClose: '&',
  },
  template: require('./tag-filter-form.pug')(),
  controller: TagFilterForm,
})
